import apiClient from './client';
import type { UserNotificationList, UnreadCount } from '../types/notifications';

export async function fetchMyNotifications(params?: {
  limit?: number;
  offset?: number;
}): Promise<UserNotificationList> {
  const { data } = await apiClient.get<UserNotificationList>(
    '/api/auth/me/notifications',
    { params },
  );
  return data;
}

export async function fetchUnreadCount(): Promise<UnreadCount> {
  const { data } = await apiClient.get<UnreadCount>(
    '/api/auth/me/notifications/unread-count',
  );
  return data;
}

export async function markNotificationRead(
  id: number,
  source: 'targeted' | 'broadcast',
): Promise<void> {
  await apiClient.patch(`/api/auth/me/notifications/${id}/read`, null, {
    params: { source },
  });
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.patch('/api/auth/me/notifications/read-all');
}
